import { render, staticRenderFns } from "./recoverpwd-1.vue?vue&type=template&id=b6785c02&"
import script from "./recoverpwd-1.vue?vue&type=script&lang=js&"
export * from "./recoverpwd-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports